







import { Component, Vue } from 'vue-property-decorator'

import RequiredStar from '@/components/lib/RequiredStar.vue'

@Component({
  components: {
    RequiredStar,
  },
})
class LabelRequired extends Vue {}

export default LabelRequired
